function getCutToken(token) {
    if (token == null || token.length < 2) return token
    return token[0] + [token[1]] +"***" + token[token.length - 2] + token[token.length - 1]
}

export default getCutToken